import React from 'react';
import Switch from 'rc-switch';
import 'rc-switch/assets/index.css';

export default function ToggleSwitch({ checked, onChange, additionalClasses, ariaLabel }) {
  return (
    <Switch
      checked={checked}
      onChange={onChange}
      className={additionalClasses}
      aria-label={ariaLabel}
    />
  );
}
